import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'

export const Route = createFileRoute('/_app/orgs/$orgId/groups/$groupId/report')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
})

function RouteComponent() {
  return <ReportComponent />
}
